export function isNullOrUndefined(value: unknown) {
  return value === null || value === undefined;
}
